import { useEffect, useState } from 'react';

const useTranslate = (text: string, language: string) => {
  const [translatedText, setTranslatedText] = useState('');

  useEffect(() => {
    if (!window['Weglot']) return;
    Promise.all([
      Weglot.translate({ words: [{ t: 1, w: text || '' }], languageTo: language }, (data: string[]) => data),
    ]).then((values: string[]) => {
      const [string] = values.flatMap((e) => e);
      setTranslatedText(string);
    });
  }, [language, text]);

  return {
    translatedText,
  };
};

export default useTranslate;
